import * as Yup from 'yup';
import dayjs from 'dayjs';

/**
 * Custom date validation that handles cross-platform date parsing issues
 * @param {*} value - The value to validate
 * @returns {boolean} - Whether the value is a valid date
 */
const isValidDate = (value) => {
  if (!value) return false;
  
  // If it's already a Date object, check if it's valid
  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }
  
  // If it's a string, try parsing with dayjs which is more consistent cross-platform
  if (typeof value === 'string') {
    const parsedDate = dayjs(value, ['MM-DD-YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY'], true);
    return parsedDate.isValid();
  }
  
  return false;
};

/**
 * Validation schema for Family Composition form.
 * Uses Yup for form validation.
 * @type {Yup.ObjectSchema}
 */

export const familyCompositionValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required'),
  birthday: Yup.mixed()
    .required('Birthday is required')
    .test('is-valid-date', 'Birthday must be a valid date', isValidDate)
    .test('not-future', 'Birthday cannot be in the future', function(value) {
      if (!isValidDate(value)) return false;
      
      let dateToCheck = value;
      if (typeof value === 'string') {
        const parsedDate = dayjs(value, ['MM-DD-YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY'], true);
        dateToCheck = parsedDate.toDate();
      }
      
      return dateToCheck <= new Date();
    })
    .nullable(),
  gender: Yup.string()
    .required(`Gender is required`),
  relationshipToChild: Yup.string()
    .required(`Relationship to child is required`),
  civilStatus: Yup.string()
    .required(`Civil Status is required`),
  educationalAttainment: Yup.string()
    .required(`Educational Attainment is required`),
    work: Yup.string()
      .nullable()
      .optional(),
    workPlace: Yup.string()
      .nullable()
      .optional(),
  salaryPerMonth: Yup.number()
    .required(`Salary per month is required`)
    .min(0, 'Salary cannot be negative')
    .typeError('Salary must be a valid number'),
  pwdId: Yup.string()
    .nullable()
    .optional()
    .matches(/^[A-Za-z0-9-]+$/, {
      message: 'Invalid PWD ID format. Only letters, numbers, and hyphens are allowed.',
      excludeEmptyString: true
    }),
  illness: Yup.string()
    .nullable(),
  vaccineStatus: Yup.string()
    .required(`Vaccine Status is required`),
});